
import { PNP_SETTINGS_APPROVAL_WORKFLOW_RESET } from "../pnp-settings.actions.types";
import { IDS } from "./pnp-approval-workflow.constants";


export const addDocumentApprovalWorkflowAddState = {
    name: IDS.app_policies_settings_approval_workflows_add,
    redirectTo: IDS.app_policies_settings_approval_workflows_add_details,
    url: '/add',
    component: 'tabs'
};

export const pnpSettingsApprovalWorkflowAddDetailsState = {
    name: IDS.app_policies_settings_approval_workflows_add_details,
    url: '',
    component: 'pnpSettingsApprovalWorkflow',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: PNP_SETTINGS_APPROVAL_WORKFLOW_RESET,
            id: 'pnpSettingsApprovalWorkflow'
        });
    }
};

export const pnpSettingsApprovalWorkflowManageState = {
    name: IDS.app_policies_settings_approval_workflows_manage,
    redirectTo: IDS.app_policies_settings_approval_workflows_manage_listing,
    url: '/manage',
    component: 'tabs'
};

export const pnpSettingsApprovalWorkflowManageListingState = {
    name: IDS.app_policies_settings_approval_workflows_manage_listing,
    url: '',
    component: 'pnpSettingsApprovalWorkflowGrid',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_policies_settings_approval_workflows_manage,
            state: [IDS.app_policies_settings_approval_workflows_manage_details]
        });
    }
};

export const pnpSettingsApprovalWorkflowManageDetailsState = {
    name: IDS.app_policies_settings_approval_workflows_manage_details,
    url: '/details?id',
    component: 'pnpSettingsApprovalWorkflow'
};
